import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { TranslateModule } from '@ngx-translate/core';
import { ActionBarItem } from "../../models/actionbar-item.interface";
import { PermissionService } from "../../services/auth/permission.service";
import { Router } from "@angular/router";

@Component({
  imports: [
    CommonModule,
    TranslateModule
  ],
  selector: "app-actionbar",
  standalone: true,
  styleUrls: ["./actionbar.component.scss"],
  templateUrl: "./actionbar.component.html"
})
export class ActionBarComponent implements OnInit {
  actionbarItemsThis: ActionBarItem[];
  titleThis: string = "";
  subtitleThis: string = "";

  @Input() title: string;
  @Input() actionBarItems: ActionBarItem[];
  @Input() subtitle: string;
  @Output() callbackEmit = new EventEmitter();

  constructor(
    public router: Router,
    private permissionService: PermissionService
  ) {}

  ngOnInit() {
    this.actionbarItemsThis = this.actionBarItems;
    if (this.title !== undefined && this.title?.length > 0) {
      this.titleThis = this.title;
    }
    if (this.subtitle !== undefined && this.subtitle?.length > 0) {
      this.subtitleThis = this.subtitle;
    }
  }

  // Gates a toolbar button by ActionBarItem.requiredPermission. Mirrors
  // DatatableComponent.shouldShowAction: backward compatible (no requiredPermission
  // => always shown) and fail-open until the permission set is loaded
  // (isReady === false), since the API is the real enforcement point
  // (dashboard-security rule #1). Called from the template *ngIf on every CD
  // cycle; has()/isReady are synchronous BehaviorSubject reads, so this is cheap.
  public shouldShow(item: ActionBarItem): boolean {
    if (!item.requiredPermission) {
      return true;
    }
    if (!this.permissionService.isReady) {
      return true;
    }
    return this.permissionService.has(item.requiredPermission);
  }

  onItemClicked(item: ActionBarItem) {
    if (item.route) {
      this.router.navigate([item.route]);
    } else if (item.callback) {
      this.callbackEmit.emit(item.callback());
    }
  }
}
